/** Приложения — встроенные ссылки на внешние сервисы (Figma/Miro/Google…).
 *  Бэкенд: backend/app/app_embeds. Сырой HTML не хранится — только нормализованный
 *  URL, прошедший белый список хостов (см. providers.py). */

export type AppEmbedScope = "global" | "department" | "user";

export interface AppEmbed {
  id: number;
  scope: AppEmbedScope;
  dept_key: string;
  title: string;
  provider: string;
  provider_title: string;
  /** Что грузим в iframe. */
  embed_url: string;
  /** Куда ведёт «Открыть в сервисе». */
  open_url: string;
  sort_order: number;
  created_by: string;
  is_mine: boolean;
  can_edit: boolean;
  created_at: string;
}

export interface AppEmbedIn {
  title: string;
  /** Embed-код из сервиса ИЛИ прямая ссылка — разбирает бэкенд. */
  code: string;
  scope: AppEmbedScope;
  dept_key?: string;
}

/** Ключ псевдо-вкладки рабочей области: приложение открывается там же, где модули. */
export const appTabKey = (id: number) => `app:${id}`;
export const parseAppTabKey = (key: string | null): number | null => {
  if (!key || !key.startsWith("app:")) return null;
  const id = Number(key.slice(4));
  return Number.isFinite(id) ? id : null;
};

/** Подписи уровней видимости — используются и в списке, и в модалке. */
export const SCOPE_TITLE: Record<AppEmbedScope, string> = {
  global: "Общие",
  department: "Отдел",
  user: "Мои",
};

export const SCOPE_HINT: Record<AppEmbedScope, string> = {
  global: "Видят все сотрудники портала",
  department: "Видят сотрудники этого отдела",
  user: "Видите только вы",
};
